<template>
  <div class="step-start">
    <div class="cta" @click="$emit('input', 'path')"><i /><span>На старт!</span></div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.step-start {
  background: rgba(#005eae, .9);
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}
.cta {
  font-size: 60px;
  line-height: 1;
  color: #ffdd8a;
  font-weight: 400;
  position: relative;
  cursor: pointer;

  @include media-down(md) {
    font-size: 32px;
  }

  span {
    position: relative;
  }

  i {
    height: 456px;
    width: 456px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: all .2s;

    &:before {
      content: '';
      background: url(../assets/achor.svg) no-repeat 0 0;
      background-size: auto 100%;
      height: 456px;
      width: 456px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      position: absolute;

      @include media-down(lg) {
        height: 300px;
        width: 300px;
      }
      @include media-down(md) {
        width: 120px;
        height: 120px;
      }
    }
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    transition: all .2s;
    border-bottom: 2px solid currentColor;
  }

  &:hover {
    i {
      transform: translate(-50%, -50%) scale(1.1);
    }
    &:after {
      transform: scale(0, 1);
    }
  }
}
</style>
